import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import SuccessModal from "../SuccessModal";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { putCartPackage } from "../../services/Cart/getCartPackage";

const TotalPackageCountModal = ({
  totalPackageCountModalVisible,
  setTotalPackageCountModalVisible,
  sendDataToTotalPackageCountModal,
  storeId,
  storeCustomerId,
  selectedPackageItemValue,
  offerPriceEnabled
}) => {
  let count = parseFloat(0.1);
  const [totalPackageCountValue, setTotalPackageCountValue] = useState(1);
  const [totalPackagePriceValue, setTotalPackagePriceValue] = useState(0);

  const [lengthCountValue, setLengthCountValue] = useState(1);
  const [widthCountValue, setWidthCountValue] = useState(1);

  useEffect(() => {
    // Check if selectedPackageItemValue is available
    if (selectedPackageItemValue) {
      // Calculate totalPackageCountValue based on selectedPackageItemValue
      // const packageCount = selectedPackageItemValue?.packageCount || 1;
      // const countGram = selectedPackageItemValue?.countGram || 0;
      setTotalPackageCountValue(0.1);
      setLengthCountValue(1);
      setWidthCountValue(1);
      setTotalPackagePriceValue(selectedPackageItemValue?.offerPrice)
    }
  }, [selectedPackageItemValue]);

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [errorText, setErrorText] = useState("");

  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);
  const [packageCountError, setPackageCountError] = useState("");
  const [packagePriceError, setPackagePriceError] = useState("");

  let itemCount = 0;
  let countGram = 0;
  if (selectedPackageItemValue?.packageDTO.serviceUnit === "Kg") {
    const value = totalPackageCountValue;
    itemCount = Math.floor(value);
    countGram = parseFloat((value - itemCount).toFixed(2));
  } else {
    const value = totalPackageCountValue;
    itemCount = Math.floor(value);
    countGram = parseFloat((value - itemCount).toFixed(2));
  }

  const handleTotalPackageCountSubmit = () => {

    if (totalPackagePriceValue === 0) {
      setErrorText("Entered Value Must Be Greater Then Zero");
    } else if (totalPackageCountValue === 0) {
      setErrorText("Entered Value Must Be Greater Then Zero");
    } else {
      setIsSubmitButtonPressed(true);
      const value = totalPackagePriceValue;
      let itemCount = 0;
      let countGram = 0;
      if (selectedPackageItemValue?.packageDTO.serviceUnit === "Kg") {
        const value = totalPackageCountValue;
        itemCount = Math.floor(value);
        countGram = parseFloat((value - itemCount).toFixed(2));
      } else {
        const value = totalPackageCountValue;
        itemCount = Math.floor(value);
        countGram = parseFloat((value - itemCount).toFixed(2));
      }
      const data = {
        id: selectedPackageItemValue.id,
        itemCount: itemCount,
        // itemCount: totalPackageCountValue.toFixed(0),
        countGram: countGram,
        // packageCount: packageCount,
        offerPrice: Number(value),
        packageDTO: {
          id: selectedPackageItemValue.packageDTO.id,
        },
      };
      if (!isNaN(totalPackageCountValue)) {
        putCartPackage(storeCustomerId, storeId, data)
          .then((response) => {
            if (!response.data.error) {
              const Res = response.data;
              setTotalPackageCountValue(parseFloat(count.toFixed(2)));
              setLengthCountValue(parseFloat(count.toFixed(2)));
              setWidthCountValue(parseFloat(count.toFixed(2)));
              sendDataToTotalPackageCountModal({
                success: true,
              });
              setTotalPackageCountModalVisible(false);
              setIsSubmitButtonPressed(false);
              setErrorText("");
            }
          })
          .catch((err) => {
            console.error("Error:", err);
          });
      } else {
        setErrorText("Input is not a number Please enter correct number");
      }
    }
  };

  const incrementPackageCount = () => {
    const incrementedCount = parseFloat(totalPackageCountValue) + 0.1;
    setTotalPackageCountValue(incrementedCount.toFixed(1)); // Ensure fixed decimal places
    setErrorText("");
  };
  const decrementPackageCount = () => {
    const decrementedCount = parseFloat(totalPackageCountValue) - 0.1;
    if (decrementedCount >= 0.2) {
      setTotalPackageCountValue(decrementedCount.toFixed(1)); // Ensure fixed decimal places
      setErrorText("");
    } else {
      setErrorText("Total Length cannot be Zero");
    }
  };

  const incrementPackageLengthCount = () => {
    const incrementedCount = parseFloat(lengthCountValue) + 0.1;
    setLengthCountValue(incrementedCount.toFixed(1)); // Ensure fixed decimal places
    // setLengthCountValue(prevPackageCount => prevPackageCount + 0.1);
  };

  // Define a function to handle PackageCount decrement
  const decrementPackageLengthCount = () => {
    const decrementedCount = parseFloat(lengthCountValue) - 0.1;
    if (decrementedCount >= 0.2) {
      setLengthCountValue(decrementedCount.toFixed(1)); // Ensure fixed decimal places
      setErrorText("");
    } else {
      setErrorText("Total Length cannot be Zero");
    }
    // if (lengthCountValue >= 0.2) {
    //   setLengthCountValue(prevPackageCount => prevPackageCount - 0.1); // Decrement PackageCount by 1 if PackageCount is greater than 0
    // }
  };

  const incrementPackageWidthCount = () => {
    const incrementedCount = parseFloat(widthCountValue) + 0.1;
    setWidthCountValue(incrementedCount.toFixed(1)); // Ensure fixed decimal places
    // setWidthCountValue(prevPackageCount => prevPackageCount + 0.1);
  };

  // Define a function to handle PackageCount decrement
  const decrementPackageWidthCount = () => {
    const decrementedCount = parseFloat(widthCountValue) - 0.1;
    if (decrementedCount >= 0.2) {
      setWidthCountValue(decrementedCount.toFixed(1)); // Ensure fixed decimal places
      setErrorText("");
    } else {
      setErrorText("Total Length cannot be Zero");
    }
    // if (widthCountValue >= 0.2) {
    //   setWidthCountValue(prevPackageCount => prevPackageCount - 0.1); // Decrement PackageCount by 1 if PackageCount is greater than 0
    // }
  };

  const calculateLengthWidth = () => {
    let sumTotalLengthCount = 0;

    sumTotalLengthCount += lengthCountValue * widthCountValue;

    const incrementedCount = parseFloat(sumTotalLengthCount);
    setTotalPackageCountValue(incrementedCount.toFixed(2)); // Ensure fixed decimal places
    // setTotalPackageCountValue(sumTotalLengthCount);
    // return sumTotalLengthCount;
  };

  const handlePackageCountChange = (text) => {
    if (text === "") {
      // Handle clearing the input field
      setTotalPackageCountValue("");
      setErrorText("Total KG cannot be Empty or Zero");
    } else {
      // Allow only valid numeric input including leading zeros and decimals
      const newPackageCount = text;
      setTotalPackageCountValue(newPackageCount);
      const parsedValue = parseFloat(newPackageCount);
      if (!isNaN(parsedValue)) {
        setErrorText("");
      } else {
        // Handle invalid input
        setErrorText("Please Enter Correct Value");
      }
    }
  };

  const handlePackageLengthCountChange = (text) => {
    if (text === "") {
      // Handle clearing the input field
      setLengthCountValue("");
      setErrorText("Total Length cannot be Empty or Zero");
    } else {
      // Allow only valid numeric input including leading zeros and decimals
      const newPackageCount = text;
      setLengthCountValue(newPackageCount);
      const parsedValue = parseFloat(newPackageCount);
      if (!isNaN(parsedValue)) {
        setErrorText("");
        // setLengthCountValue(newPackageCount); // Update PackageCount state with the new value
      } else {
        // Handle invalid input
        setErrorText("Please Enter Correct Value");
      }
    }
  };

  const handlePackageWidthCountChange = (text) => {
    if (text === "") {
      // Handle clearing the input field
      setWidthCountValue("");
      setErrorText("Total Width cannot be Empty or Zero");
    } else {
      // const newPackageCount = parseInt(text);
      const newPackageCount = text;
      setWidthCountValue(newPackageCount);
      const parsedValue = parseFloat(newPackageCount);
      if (!isNaN(parsedValue)) {
        setErrorText("");
        // setWidthCountValue(newPackageCount); // Update PackageCount state with the new value
      } else {
        // Handle invalid input
        setErrorText("Please Enter Correct Value");
      }
    }
  };

  const handlePackagePriceChange = (text) => {

    const inputRegex = /^\d*$/;

    if (!inputRegex.test(text)) return;

    if (text === "") {
      // Handle clearing the input field
      setTotalPackagePriceValue("");
      setErrorText("Price cannot be Empty or Zero");
    } else {
      // Allow only valid numeric input including leading zeros and decimals
      const newPackagePrice = text;
      setTotalPackagePriceValue(newPackagePrice);
      const parsedValue = parseInt(newPackagePrice);
      if (!isNaN(parsedValue)) {
        setErrorText("");
      } else {
        // Handle invalid input
        setErrorText("Please Enter Correct Value");
      }
    }
  };

  useEffect(() => {
    if (lengthCountValue > 0 && widthCountValue > 0) calculateLengthWidth();
    // setErrorText('');
  }, [lengthCountValue, widthCountValue]);

  const handleModalClose = () => {
    setTotalPackageCountValue(parseFloat(count.toFixed(2)));
    setLengthCountValue(parseFloat(count.toFixed(2)));
    setWidthCountValue(parseFloat(count.toFixed(2)));
    setIsSubmitButtonPressed(false);
    sendDataToTotalPackageCountModal({
      success: true,
    });
    setTotalPackageCountModalVisible(!totalPackageCountModalVisible);
    setErrorText("");
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={totalPackageCountModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!totalPackageCountModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div>
              <div>
                <div
                  className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
                  style={{
                    backgroundImage:
                      "radial-gradient(circle at left top, #2B70D7, #1752AA)",
                  }}
                >
                  <img
                    src={"Laundy_App_Icons_Gifs/Packages_GIFs/package1.gif"}
                    style={{
                      width: 50,
                      height: 50,
                    }}
                  />
                  <p className=" text-4xl text-primary-50 font-semibold">
                    Package Count
                  </p>
                  <Button
                    label="x"
                    onClick={(e) => hide(e)}
                    text
                    className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
                  ></Button>
                </div>
                {offerPriceEnabled && !selectedPackageItemValue?.packageDTO?.carryForward && <div className="my-3 mx-4">
                  <div className="flex flex-row justify-content-between align-items-center">
                    <div>
                      <p className=" text-xl font-semibold">Price : </p>
                    </div>
                    <div className="flex flex-row justify-content-center align-items-center">


                      <div>
                        <InputText
                          value={totalPackagePriceValue}
                          maxLength={50}
                          onChange={(e) =>
                            handlePackagePriceChange(e.target.value)
                          }
                          className="w-full bg-white-alpha-20 border-round-lg px-3 text-md "
                        ></InputText>

                        {packagePriceError !== "" && (
                          <p>{packagePriceError}</p>
                        )}
                      </div>

                    </div>
                  </div>
                </div>}

                {selectedPackageItemValue?.packageDTO?.serviceUnit === "Kg" ? (
                  <div className="my-3 mx-4">
                    <div className="flex flex-row justify-content-between align-items-center">
                      <div>
                        <p className=" text-xl font-semibold">KG : </p>
                      </div>
                      <div className="flex flex-row justify-content-center align-items-center">
                        <div
                          onClick={() => decrementPackageCount()}
                          className="justify-content-center align-items-center  shadow-4 mx-2 cursor-pointer"
                          style={{
                            backgroundColor: "#2B70D7",
                            borderRadius: 50, // Make it circular (adjust the value as needed)
                            width: 30, // Width of the button
                            height: 30, // Height of the button
                          }}
                        >
                          <p className="text-xl font-bold text-white text-center">
                            -
                          </p>
                        </div>

                        <div>
                          <InputText
                            value={totalPackageCountValue}
                            maxLength={50}
                            onChange={(e) =>
                              handlePackageCountChange(e.target.value)
                            }
                            className="w-full bg-white-alpha-20 border-round-lg px-3 text-md "
                          ></InputText>

                          {packageCountError !== "" && (
                            <p>{packageCountError}</p>
                          )}
                        </div>
                        <div
                          onClick={() => incrementPackageCount()}
                          className="justify-content-center align-items-center  shadow-4 mx-2 cursor-pointer"
                          style={{
                            backgroundColor: "#2B70D7",
                            borderRadius: 50, // Make it circular (adjust the value as needed)
                            width: 30, // Width of the button
                            height: 30, // Height of the button
                          }}
                        >
                          <p className="text-xl font-bold text-white text-center">
                            +
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      marginTop: 5,
                      marginBottom: 10,
                      alignSelf: "center",
                    }}
                  >
                    <React.Fragment>
                        <div className="my-3 mx-4">
                        <div className="flex flex-row justify-content-between align-items-center">
                          <div>
                            <p className=" text-xl font-semibold">L : </p>
                          </div>
                          <div className="flex flex-row justify-content-center align-items-center">
                            <div
                              onClick={() => decrementPackageLengthCount()}
                              className="justify-content-center align-items-center  shadow-4 mx-2 cursor-pointer"
                              style={{
                                backgroundColor: "#2B70D7",
                                borderRadius: 50, // Make it circular (adjust the value as needed)
                                width: 30, // Width of the button
                                height: 30, // Height of the button
                              }}
                            >
                              <p className="text-xl font-bold text-white text-center">
                                -
                              </p>
                            </div>

                            <div>
                              <InputText
                                value={lengthCountValue}
                                maxLength={50}
                                onChange={(e) =>
                                  handlePackageLengthCountChange(e.target.value)
                                }
                                  className="w-full bg-white-alpha-20 border-round-lg px-3 text-md "
                              ></InputText>

                              {packageCountError !== "" && (
                                <p>{packageCountError}</p>
                              )}
                            </div>
                            <div
                              onClick={() => incrementPackageLengthCount()}
                              className="justify-content-center align-items-center  shadow-4 mx-2 cursor-pointer"
                              style={{
                                backgroundColor: "#2B70D7",
                                borderRadius: 50, // Make it circular (adjust the value as needed)
                                width: 30, // Width of the button
                                height: 30, // Height of the button
                              }}
                            >
                              <p className="text-xl font-bold text-white text-center">
                                +
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                        <div className="my-3 mx-4">
                        <div className="flex flex-row justify-content-between align-items-center">
                          <div>
                            <p className=" text-xl font-semibold">W : </p>
                          </div>
                          <div className="flex flex-row justify-content-center align-items-center">
                            <div
                              onClick={() => decrementPackageWidthCount()}
                              className="justify-content-center align-items-center  shadow-4 mx-2 cursor-pointer"
                              style={{
                                backgroundColor: "#2B70D7",
                                borderRadius: 50, // Make it circular (adjust the value as needed)
                                width: 30, // Width of the button
                                height: 30, // Height of the button
                              }}
                            >
                              <p className="text-xl font-bold text-white text-center">
                                -
                              </p>
                            </div>

                            <div>
                              <InputText
                                value={widthCountValue}
                                maxLength={50}
                                onChange={(e) =>
                                  handlePackageWidthCountChange(e.target.value)
                                }
                                  className="w-full bg-white-alpha-20 border-round-lg px-3 text-md "
                              ></InputText>

                              {packageCountError !== "" && (
                                <p>{packageCountError}</p>
                              )}
                            </div>
                            <div
                              onClick={() => incrementPackageWidthCount()}
                              className="justify-content-center align-items-center  shadow-4 mx-2 cursor-pointer"
                              style={{
                                backgroundColor: "#2B70D7",
                                borderRadius: 50, // Make it circular (adjust the value as needed)
                                width: 30, // Width of the button
                                height: 30, // Height of the button
                              }}
                            >
                              <p className="text-xl font-bold text-white text-center">
                                +
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                        <div className="mx-4">
                        <div>
                          <p className=" text-xl font-semibold ">
                            Total Area: {totalPackageCountValue.toString()}
                          </p>
                        </div>
                      </div>
                    </React.Fragment>
                  </div>
                )}
                {errorText && (
                  <div
                    style={{
                      marginTop: 2,
                      marginLeft: 10,
                      marginBottom: 10,
                      alignSelf: "center",
                      color: "red"
                    }}
                  >
                    <p>{errorText}</p>
                  </div>
                )}
              </div>

            </div>
            <Button
              disabled={isSubmitButtonPressed}
              onClick={handleTotalPackageCountSubmit}
              className="mt-1 mb-3 mx-4 border-round-xl "
            >
              <p className=" w-full text-2xl  font-semibold flex justify-content-center">
                SUBMIT
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
      <SuccessModal
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        status={modalStatus}
        text={modalText}
      />
    </div>
  );
};

export default TotalPackageCountModal;
